/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

// One loader per route; shared by lazy() and prefetchRoute.
export const load = {
  '/': () => import('@/features/mfg/ManufacturingHomePage'),
  '/repair-overview': () => import('@/features/mfg/RepairOverviewPage'),
  '/online': () => import('@/features/mfg/OnlinePage'),
  '/mmt': () => import('@/features/mfg/MmtDetailPage'),
  '/offline': () => import('@/features/mfg/OfflinePage'),
  '/gsip': () => import('@/features/mfg/GsipOverviewPage'),
  '/dtc': () => import('@/features/mfg/DtcSearchPage'),
  '/diagnostic': () => import('@/features/mfg/DiagnosticPage'),
  '/schematic-explorer': () => import('./pages/ExplorerPage'),
  '/mecl': () => import('./pages/MeclPage'),
  '/viewer-3d': () => import('./pages/Viewer3DPage'),
  '/resource-links': () => import('./pages/ResourceLinksPage'),
  '/engineering-diagnostics': () => import('@/features/engineering/EngineeringDiagnosticsPage'),
  '/engineering-diagnostics/parts': () => import('@/features/engineering/PartSearchPage'),
  '/engineering-diagnostics/failures': () => import('@/features/engineering/FailureAnalyticsPage'),
  '/engineering-diagnostics/assistant': () =>
    import('@/features/engineering/assistant/EngineeringAssistantPage'),
  '/analytics': () => import('./pages/AnalyticsPage'),
  '/admin': () => import('./pages/AdminPage'),
  '/unauthorized': () => import('./pages/UnauthorizedPage'),
  '*': () => import('./pages/NotFoundPage'),
} as const;

/**
 * Prefetch a route chunk on nav hover/focus. Errors are swallowed: a failed
 * prefetch (e.g. stale chunk after a redeploy) must not reload the page on hover
 * or surface as an unhandled rejection — the real navigation handles recovery.
 */
export function prefetchRoute(path: string): void {
  const loader = load[path as keyof typeof load];
  if (loader) loader().catch(() => {});
}
